import Component from '../core/Component'
import Scroll from '../services/Scroll'

export const STATES = {
    ACTIVE: 'is-active'
}

export default class Floater extends Component {

    constructor(element) {
        super(element)

        this.options = {
            from: null,
            to: null
        }

        if (this.element.dataset.options) {
            const options = JSON.parse(this.element.dataset.options)

            this.options = {
                ...this.options,
                ...options
            }
        }

        this.limit = {
            min: -Infinity,
            max: Infinity
        }

        this.isActive = false
    }

    prepare() {
        Scroll.on('resize', this.handleResize)
        Scroll.on('scroll', this.handleScroll)
        this.resize()
    }

    handleResize = () => {
        this.resize()
    }

    handleScroll = ({ offset }) => {
        this.render(offset.y)
    }

    resize() {
        const from = this.options.from ? document.querySelector(this.options.from) : null
        const to = this.options.to ? document.querySelector(this.options.to) : null

        const offset = Scroll.getScroll().y

        this.limit = {
            min: from ? from.getBoundingClientRect().top + offset : -Infinity,
            max: to ? to.getBoundingClientRect().top + offset - window.innerHeight : Infinity
        }
    }

    render(scrollTop) {
        if (scrollTop > this.limit.min && scrollTop < this.limit.max) {
            if (!this.isActive) {
                this.isActive = true
                this.element.classList.add(STATES.ACTIVE)
            }
        } else {
            if (this.isActive) {
                this.isActive = false
                this.element.classList.remove(STATES.ACTIVE)
            }
        }
    }

}
